import FormCondition from './conditions';
import FormAjax from './ajax';
import { groupBy } from '../helpers/others'

class Form
{
    constructor() {
        if (!window.form) return;

        this.selectors = [
            'input[name][data-field]',
            'select[name][data-field]',
            'textarea[name][data-field]',
            'p[data-field]'
        ];

        this.forms = document.querySelectorAll('.forms-module[data-form]');
        this.forms.forEach(moduleEl => {
            const formId = moduleEl.dataset.form;
            const formEl = moduleEl.querySelector('form');
            if (formId && window.form[formId]) {
                // Assign form options to element
                for (const key in window.form[formId]) {
                    if (window.form[formId].hasOwnProperty(key)) {
                        moduleEl[key] = window.form[formId][key];
                    }
                }
                // Get fields
                const fields = groupBy(moduleEl.querySelectorAll(this.selectors.join(', ')), field => field.dataset.field);
                // Init form
                this.initForm(moduleEl, formEl, fields, window.form[formId]);
            }
        });
    }
    initForm(moduleEl, formEl, fields, options) {
        new FormCondition(moduleEl, formEl, fields, options);
        new FormAjax(moduleEl, formEl, fields, options);
    }
}

export default Form;